import React, { useState, Fragment, useEffect, useLayoutEffect } from 'react';
import styles from './ScheduledConTrend.module.css';
import { Card, Col, Input, Row, Select, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';
import { newCons, modCons, remCons, cardCss, tabPageCss } from './columns';
const { Option } = Select;
const { Text } = Typography;

const ScheduledConTrend = (props) => {
    const [renderer, updateRender] = useState('tab1');
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);
    const key = props.usrSch == 'Scheduled' ? 1 : props.usrSch == 'Deployed' ? 0 : 2;

    useEffect(() => {
        if (props.loader === false) {
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loader]);

    const fetchData = async () => {
        setLoad(true);
        const data = await fetchJsData({
            type: 'fetch',
            qry: 'fetWkConnChanges',
            firstVal: props.usrRel,
            secondVal: props.usrRel,
        });
        setData({
            newCon: data['data'].filter((x) => x.request_type === 'added'),
            modCon: data['data'].filter((x) => x.request_type === 'modified'),
            remCon: data['data'].filter((x) => x.request_type === 'removed'),
        });
        setLoad(false);
    };

    const onTabChng = (key) => {
        updateRender(key);
        props.setSubmit(!props.submit);
    };

    const contentList = {
        tab1: <FetchTabSearch submit={props.submit} col={newCons} data={data['newCon']} usrSch={key} key={'1'} />,
        tab2: <FetchTabSearch submit={props.submit} col={modCons} data={data['modCon']} usrSch={key} key={'2'} />,
        tab3: <FetchTabSearch submit={props.submit} col={remCons} data={data['remCon']} usrSch={key} key={'3'} />,
    };

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                {/* <Col className="gutter-row" span={1}></Col> */}
                <Col className="gutter-row" span={23}>
                    <Card
                        style={{ width: '100%', minHeight: '80vh' }}
                        bodyStyle={cardCss}
                        tabList={tabList}
                        onTabChange={onTabChng}
                        // loading={load}
                    >
                        {!load ? (
                            contentList[renderer]
                        ) : (
                            <div className={styles.spinner}>
                                <Spin size="small" />
                            </div>
                        )}
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(true);
    const schData = props.usrSch !== 2 ? props.data.filter((x) => x.scheduled === props.usrSch) : props.data;

    const schColIndicator = props.usrSch === 1 ? 'Scheduled Date' : props.usrSch === 0 ? 'Deployed Date' : 'Scheduled / Deployed Date';

    useEffect(() => {
        setLoading(true);

        setOrigData(schData);
        setFilteredData(schData);
        const searchInd = schData.map((user) => {
            const allValues = crawl(user);
            return { allValues: allValues.toString() };
        });
        setSearchIndex(searchInd);

        setLoading(false);
    }, [props.usrSch]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.usrSch]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={6}>
                                            <Text>{props.usrSch === 1 ? 'Scheduled' : props.usrSch === 0 ? 'Deployed' : 'All'}</Text>
                                        </Col>
                                    </Row>
                                )
                            }
                            size="small"
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length, schColIndicator)}
                                    loading={false}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const tabList = [
    {
        key: 'tab1',
        tab: 'New Connectors',
    },
    {
        key: 'tab2',
        tab: 'Modified Connectors',
    },
    {
        key: 'tab3',
        tab: 'Removed Connectors',
    },
];

export default ScheduledConTrend;
